<template>
  <div class="flex w-full h-full gap-10" style="height: calc(100% - 200px)">
    <div class="skeleton-box">
      <div class="w-full h-full flex flex-col">
        <div class="flex justify-between gap-5 pb-4">
          <Skeleton class="w-40 item-header" />
          <div class="spacer"></div>
          <Skeleton class="w-10 item-header" />
          <Skeleton class="w-10 item-header" />
          <Skeleton class="w-40 item-header" />
        </div>
        <Skeleton class="flex-1 w-full h-full rounded" />
      </div>
    </div>
    <div class="skeleton-box">
      <div class="w-full h-full flex flex-col">
        <div class="flex justify-between gap-5 pb-4">
          <Skeleton class="w-40 item-header" />
          <div class="spacer"></div>
          <Skeleton class="w-10 item-header" />
          <Skeleton class="w-10 item-header" />
          <Skeleton class="w-40 item-header" />
        </div>
        <Skeleton class="flex-1 w-full h-full rounded" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { Skeleton } from "@/shared/ui/skeleton";
</script>

<style scoped>
.item-header {
  @apply h-6 rounded;
}

.spacer {
  flex-grow: 1;
}

.skeleton-box {
  @apply flex w-full h-full p-5 rounded-lg shadow-sm;
  background-color: hsl(var(--card));
  min-width: 250px;
}
</style>
